import { render, staticRenderFns } from "./wheatPic.vue?vue&type=template&id=71fa546c&scoped=true&"
import script from "./wheatPic.vue?vue&type=script&lang=js&"
export * from "./wheatPic.vue?vue&type=script&lang=js&"
import style0 from "./wheatPic.vue?vue&type=style&index=0&id=71fa546c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fa546c",
  null
  
)

export default component.exports